var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3ComfortMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18v-8a2 2 0 114 0v8a2 2 0 01-4 0zm-13.5 7.3a2 2 0 002.8-2.8l-5.7-5.7a2.1 2.1 0 00-2.6 0 2 2 0 00-.2 2.8l5.7 5.7zM20 38a2 2 0 00-2-2h-8a2 2 0 100 4h8a2 2 0 002-2zm2.5 12.7l-5.7 5.7a2.1 2.1 0 000 2.6 2 2 0 002.8.2l5.7-5.7a2 2 0 10-2.8-2.8zM38 56a2 2 0 00-2 2v8a2 2 0 004 0v-8a2 2 0 00-2-2zm15.5-5.3a2 2 0 00-2.8 2.8l5.7 5.7a2.1 2.1 0 002.6 0 2 2 0 00.2-2.8l-5.7-5.7zM66 36h-8a2 2 0 000 4h8a2 2 0 000-4zM53.5 25.3l5.7-5.7a2.1 2.1 0 000-2.6 2 2 0 00-2.8-.2l-5.7 5.7a2 2 0 002.8 2.8zM52 37.9a14 14 0 11-28 0 14 14 0 0128 0zm-4 0a10 10 0 10-20 0 10 10 0 0020 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Comfort_mode.2a008ddf.svg";
export { SvgB3ComfortMode as ReactComponent };